<template>
  <div class="d-flex flex-column justify-content-between">
    <div class="d-flex flex-column">
      <!-- Card Infomation -->
      <div id="card-infomation">
        <b-card class="card-border-radius common-shadow noborder" body-class="body-landing">
          <div class="">
            <b-row cols="2" class="mt-1 pt-1">
              <b-col class="text-left text-align-self-start" cols="5">
                <span style="vertical-align: baseline"
                  class="font-anuphan-regular-14 text-revamp-color-grey">หมายเลขใบสมัคร</span>
              </b-col>
              <b-col class="text-right px-0" cols="7" style="padding-right: 15px !important">
                <span class="font-anuphan-regular-16-400 text-revamp-color-black" style="vertical-align: baseline">{{
                  userData.loanAppId }}</span></b-col>
            </b-row>
            <b-row cols="2" class="mt-1" style="line-height: 24px">
              <b-col class="text-left text-align-self-end px-0" style="
                  padding-left: 15px !important ;
                  line-height: 24px;
                  vertical-align: baseline;
                " cols="5">
                <span style="vertical-align: baseline"
                  class="font-anuphan-regular-14 text-revamp-color-grey">อัปโหลดภายในวันที่</span>
              </b-col>
              <b-col class="text-right" cols="7">
                <span class="font-anuphan-bold-16 text-revamp-color-black"
                  style="line-height: 24px; vertical-align: baseline">{{ covertExpiredDate(userData.expiredDate)
                  }}</span></b-col>
            </b-row>
            <b-row v-if="userData.expireDay <= 5" cols="2" class="mt-1" style="line-height: 24px">
              <b-col class="text-left" cols="6"> </b-col>
              <b-col class="text-right font-anuphan-regular-16-400 text-revamp-color-danger">
                <span v-if="userData.expireDay > 1 && userData.expireDay <= 5">อีก {{ userData.expireDay }} วัน</span>
                <span v-else-if="userData.expireDay == 1">วันนี้วันสุดท้าย</span>
              </b-col>
            </b-row>
          </div>
          <div class="w-100 border-top-NEXT" style="margin-top: 16px; margin-bottom: 16px" />
          <b-row>
            <b-col>
              <span class="font-anuphan-regular-14 text-revamp-color-grey">เตรียมเอกสารให้ครบถ้วนก่อนดำเนินการ</span>
            </b-col>
            <div class="w-100"></div>
            <b-col>
              <span class="font-anuphan-regular-14 text-revamp-color-grey">หากคุณปิดหน้านี้
                <span class="font-anuphan-bold-14 text-revamp-color-grey">เอกสารของคุณจะไม่ถูกบันทึก</span></span>
            </b-col>
          </b-row>
        </b-card>
      </div>
      <!-- Document Required -->
      <div id="card-document-list" v-if="groupRequire.length > 0">
        <div class="pt-3">
          <span class="font-anuphan-bold-18 text-revamp-color-black">เอกสารประกอบการสมัคร</span>
        </div>

        <div class="justify-content-md-center mt-3" v-for="(item, key) in groupRequire" :key="key">
          <template>
            <b-card class="card-border-radius common-shadow" body-class="body-landing" @click="
                  item.doc_group_code == '01'
                    ? goToDocumentGroup(item.doc_group_code, item.state)
                    : ''
                  " :class="checkBorderColor(item.state) === 'danger'
                  ? 'card-danger'
                  : checkBorderColor(item.state) === 'warning'
                    ? 'card-warning'
                    : 'noborder'
                  ">
              <b-row style="line-height: 32px">
                <b-col cols="1">
                  <template v-if="item.state == 'attachfile'">
                    <b-iconstack font-scale="1.5">
                      <b-icon stacked icon="circle" style="color: var(--color-text-success)"></b-icon>
                      <b-icon stacked icon="check" style="color: var(--color-text-success)"></b-icon>
                    </b-iconstack>
                  </template>
                  <template v-else-if="item.state == 'success'">
                    <b-iconstack font-scale="1.5">
                      <b-icon stacked icon="circle-fill" style="color: var(--color-text-success)"></b-icon>
                      <b-icon stacked icon="check" style="color: #fff"></b-icon>
                    </b-iconstack>
                  </template>
                  <template v-else-if="item.state == 'error'">
                    <b-badge pill class="badge-wait badge-container object-center">
                      <span class="font-anuphan-regular-14 object-center" style="line-height: 18px">
                        {{ key + 1 }}
                      </span>
                    </b-badge>
                  </template>
                  <template v-else-if="item.state == 'warning'">
                    <b-iconstack font-scale="1.5">
                      <b-icon stacked icon="circle-fill" style="color: var(--color-text-warning)"></b-icon>
                      <b-icon stacked icon="check" style="color: #fff"></b-icon>
                    </b-iconstack>
                  </template>
                  <template v-else>
                    <b-badge pill class="badge-wait badge-container object-center">
                      <span class="font-anuphan-regular-14 object-center" style="line-height: 18px">
                        {{ key + 1 }}
                      </span>
                    </b-badge>
                  </template>
                </b-col>
                <b-col class="px-0 text-left" col style="
                    padding-left: 34px !important;
                    padding-right: 6% !important;
                  ">
                  <b-row align-v="center">
                    <b-col align-self="center">
                      <span class="font-anuphan-bold-16" style="white-space: normal; word-break: break-word" :class="item.state != 'success'
                  ? 'text-revamp-color-black'
                  : 'text-revamp-color-after-success'
                  ">{{ item.doc_short_name }}</span>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="1" class="px-0" v-b-toggle="'my-collapse-' + item.doc_code"
                  style="line-height: 32px; padding-right: 32px !important">
                  <template v-if="item.doc_group_code != '01'">
                    <b-icon v-if="item.state != 'success'" icon="chevron-up" font-scale="1.3"
                      style="color: var(--color-primary); margin-bottom: 25%"
                      :class="item.collapse ? 'chevron-up' : 'chevron-down'" />
                  </template>
                  <template v-else>
                    <b-icon icon="chevron-right" font-scale="1.3" v-if="item.state != 'success'"
                      style="color: var(--color-primary); margin-bottom: 25%" />
                  </template>
                </b-col>
              </b-row>
              <b-row v-if="item.state != 'success'">
                <b-col cols="1" style="width: 34px !important"></b-col>
                <b-col style="padding-left: 34px !important">
                  <span class="font-anuphan-regular-14" :class="item.state == 'overlimit'
                  ? 'text-revamp-color-danger'
                  : 'text-revamp-color-grey'
                  ">{{
                  item.state == "overlimit" ? "ขนาดเกินมา" : "เหลือพื้นที่"
                }}
                    <b :class="item.state == 'overlimit'
                    ? 'text-revamp-color-danger'
                    : 'text-revamp-color-size-black'
                  ">{{
                  getFileSizeAndType(
                    Number(
                      item.filesReal.length > 0
                        ? Math.abs(item.totalFileSize)
                        : item.max_size * (1000 * 1000)
                    )
                  )
                }}
                    </b>
                  </span>
                </b-col>
              </b-row>

              <template v-if="userData.followupStatus.code == 'RESUBMIT' &&
                  item.reason_request != undefined &&
                  item.reason_request != '' &&
                  checkHistoryUpload(item.doc_code) &&
                  ['overlimit', 'wait', 'attachfile'].includes(item.state) &&
                  item.collapse
                  ">
                <b-card class="card-border-radius noborder mt-3" style="background-color: #fff8f1"
                  body-class="body-landing">
                  <b-row>
                    <b-col cols="1" align-self="center">
                      <b-img center :src="revampIconResubmit" width="16" height="16" />
                    </b-col>
                    <b-col align-self="center">
                      <b class="text-revamp-color-orange-dark font-anuphan-bold-14">{{ item.reason_request }}</b>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="1" align-self="center">
                      <b-col> </b-col>
                    </b-col>
                    <b-col align-self="start">
                      <span class="text-revamp-color-orange-dark font-anuphan-regular-14">{{ item.reason_note }}</span>
                    </b-col>
                  </b-row>
                </b-card>
              </template>

              <b-row v-if="item.state == 'error'" class="pt-1">
                <b-col cols="1" style="width: 34px !important"></b-col>
                <b-col style="padding-left: 34px !important">
                  <span class="font-anuphan-bold-14 text-revamp-color-danger">อัปโหลดไม่สำเร็จ
                    กรุณาลองใหม่อีกครั้ง</span>
                </b-col>
              </b-row>
              <b-row v-if="item.state == 'warning'" class="pt-2">
                <b-col cols="1" style="width: 34px !important"></b-col>
                <b-col style="padding-left: 34px !important">
                  <span class="font-anuphan-bold-14 text-revamp-color-orange">อัปโหลดไม่สำเร็จ
                    กรุณาตรวจสอบและลองใหม่อีกครั้ง</span>
                </b-col>
              </b-row>
              <b-row v-if="item.state == 'success'">
                <b-col cols="1" style="width: 34px !important"></b-col>
                <b-col style="padding-left: 34px !important">
                  <span class="font-anuphan-bold-14 text-revamp-color-success">อัปโหลดสำเร็จ</span>
                </b-col>
              </b-row>
              <template v-if="item.doc_group_code != '01' && item.state != 'success'">
                <div v-if="item.state == 'error' ||
                  item.state == 'wait' ||
                  item.state == 'attachfile'
                  " />
                <b-collapse :id="'my-collapse-' + item.doc_code" v-model="item.collapse" visible>
                  <b-row>
                    <b-col align-self="center">
                      <hr style="
                          height: 1px;
                          width: 100%;
                          background-color: #e5e7eb;
                        " />
                    </b-col>
                  </b-row>
                  <b-row class="pt-2">
                    <b-col align-self="center">
                      <componentMiniUpload :documentTypeObj="item" :viewRecommend="true" v-if="showSubmited()"
                        :callback="callbackSetStateDocumentType" :onReceiveNativeCommand="onReceiveNativeCommand" />
                    </b-col>
                  </b-row>
                </b-collapse>
              </template>
            </b-card>
          </template>
        </div>
      </div>

      <!-- Document Deviate -->
      <div class="mt-3" id="card-document-deviate-list"
        v-if="(userData.showRDdocument && !userData.rdIsMandatory) || lstDocumentTypeDeviate.length > 0">
        <div>
          <b class="font-anuphan-bold-18 text-revamp-color-black">เอกสารเพิ่มโอกาสพิจารณา (ไม่บังคับ)</b>
        </div>
        <div class="mt-3 justify-content-md-center" v-if="userData.showRDdocument && !userData.rdIsMandatory">
          <b-card class="card-border-radius common-shadow noborder" body-class="body-landing py-3"
            @click="openPopupRDdocument()">

            <!-- RD document -->
            <b-row style="line-height: 32px" class="text-center">
              <b-col cols="1">
                <template v-if="!rdFlag">
                  <b-badge pill class="badge-wait badge-container object-center" style="margin-top: 2px !important;">
                    <span class="font-anuphan-regular-14 object-center" style="line-height: 18px">
                      1
                    </span>
                  </b-badge>
                </template>
                <template v-else>
                  <b-iconstack font-scale="1.5">
                    <b-icon stacked icon="circle" style="color: var(--color-text-success)"></b-icon>
                    <b-icon stacked icon="check" style="color: var(--color-text-success)"></b-icon>
                  </b-iconstack>
                </template>

              </b-col>
              <b-col class="px-0 text-left" col style="
                    padding-left: 34px !important;
                    padding-right: 6% !important;
                  ">
                <b-row align-v="center">
                  <b-col align-self="center" cols="12">
                    <span class="font-anuphan-bold-14 d-wallet-border-radius"
                      style="white-space: normal; word-break: break-word;padding-inline: 8px;">
                      แนะนำ
                    </span>
                  </b-col>
                  <div class="w-100"></div>
                  <b-col align-self="center" cols="12" style="line-height: 14px">
                    <span class="font-anuphan-bold-16" style="white-space: normal; word-break: break-word">
                      ยื่นเอกสารผ่านบริการ dDocument <br>
                    </span>
                    <span class="font-anuphan-regular-14" style="white-space: normal; word-break: break-word">
                      สะดวก รวดเร็ว ไม่ต้องอัปโหลดเอกสารเอง
                    </span>
                  </b-col>
                  <template v-if="rdFlag">
                    <div class="w-100"></div>
                    <b-col align-self="center" cols="12">
                      <span class="font-anuphan-bold-14 text-revamp-color-orange-light"
                        style="white-space: normal; word-break: break-word ;">
                        รอยืนยันเอกสาร
                      </span>

                    </b-col>
                    <div class="w-100"></div>
                    <b-col align-self="center" cols="12" style="line-height: 14px">
                      <span class="font-anuphan-regular-14 text-revamp-color-grey"
                        style="white-space: normal; word-break: break-word">
                        ระบบจะพาไปยืนยันเอกสารด้วย dDocument <br>
                      </span>
                      <span class="font-anuphan-regular-14 text-revamp-color-grey"
                        style="white-space: normal; word-break: break-word">
                        หลังจากอัปโหลดเอกสารประเภทอื่นๆ สำเร็จ
                      </span>
                    </b-col>
                    <div class="w-100"></div>
                    <b-col align-self="center" cols="12">
                      <span class="span-aherf-text font-anuphan-regular-12 view-example">ยกเลิก</span>
                    </b-col>
                  </template>
                </b-row>
              </b-col>
              <b-col cols="1" class="px-0" style="line-height: 32px; padding-right: 32px !important">
                <b-icon icon="chevron-right" font-scale="1.3" style="color: var(--color-primary); margin-bottom: 25%" />
              </b-col>
            </b-row>
          </b-card>


        </div>
        <div class="mt-3 justify-content-md-center" v-if="lstDocumentTypeDeviate.length > 0">
          <b-card class="card-border-radius common-shadow noborder" body-class="body-landing py-3" :class="checkBorderColor(deviateState) === 'danger' ||
                  checkBorderColor(deviateState) === 'warning'
                  ? 'card-warning'
                  : 'noborder'
                  ">
            <b-row style="line-height: 32px" @click="
                  deviateState != 'success' ? goToDocumentGroupDeviate() : ''
                  ">
              <b-col cols="1">
                <template v-if="deviateState == 'error'">
                  <b-iconstack font-scale="1.5">
                    <b-icon stacked icon="circle-fill" style="color: var(--color-text-warning)"></b-icon>
                    <b-icon stacked icon="check" style="color: #fff"></b-icon>
                  </b-iconstack>
                </template>
                <template v-else-if="deviateState == 'warning'">
                  <b-iconstack font-scale="1.5">
                    <b-icon stacked icon="circle-fill" style="color: var(--color-text-warning)"></b-icon>
                    <b-icon stacked icon="check" style="color: #fff"></b-icon>
                  </b-iconstack>
                </template>
                <template v-else-if="deviateState == 'attachfile'">
                  <b-iconstack font-scale="1.5">
                    <b-icon stacked icon="circle" style="color: var(--color-text-success)"></b-icon>
                    <b-icon stacked icon="check" style="color: var(--color-text-success)"></b-icon>
                  </b-iconstack>
                </template>
                <template v-else-if="deviateState == 'success'">
                  <b-iconstack font-scale="1.5">
                    <b-icon stacked icon="circle-fill" style="color: var(--color-text-success)"></b-icon>
                    <b-icon stacked icon="check" style="color: #fff"></b-icon>
                  </b-iconstack>
                </template>
                <template v-else-if="deviateState == 'wait' || deviateState == 'overlimit'
                  ">
                  <b-badge pill class="badge-wait badge-container object-center">
                    <span class="font-anuphan-bold-14 object-center" style="line-height: 18px">
                      {{ !userData.rdIsMandatory ? 2 : 1 }}
                    </span>
                  </b-badge>
                </template>
              </b-col>
              <b-col class="px-0 text-left" col style="padding-left: 34px !important">
                <b-row>
                  <b-col col style="line-height: 32px">
                    <b class="font-anuphan-bold-16" :class="deviateState != 'success'
                  ? 'text-revamp-color-black'
                  : 'text-revamp-color-after-success'
                  " style="font-size: 16px">เอกสารเพิ่มเติม</b>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="1" class="px-0" align-self="center"
                style="line-height: 32px; padding-right: 32px !important">
                <b-icon v-if="deviateState != 'success'" icon="chevron-right" font-scale="1.3"
                  style="color: var(--color-primary); margin-bottom: 25%" />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="1" style="width: 34px !important"></b-col>
              <b-col style="padding-left: 34px !important">
                <template v-if="deviateState != 'success'">
                  <span class="font-anuphan-regular-14 text-revamp-color-grey">เหลือพื้นที่
                    <b class="text-revamp-color-size-black">
                      {{ sumMaxSizeByListDocumentType }}
                    </b>
                  </span>
                </template>
                <template v-else>
                  <span class="text-revamp-color-success font-anuphan-bold-14">
                    อัปโหลดสำเร็จ
                  </span>
                </template>
                <b-row class="pt-2">
                  <b-col align-self="center" style="line-height: 16px" cols="12"
                    v-for="(item, key) in lstDocumentTypeDeviate" :key="key">
                    <b-row>
                      <b-col cols="1" style="margin-left: -1vw">
                        <b-icon icon="dot"></b-icon>
                      </b-col>
                      <b-col>
                        <p class="font-anuphan-regular-14 text-revamp-color-grey"
                          style="white-space: normal; word-break: break-word">
                          {{ item.doc_short_name }}
                        </p>
                      </b-col>
                    </b-row>
                    <b-row v-if="item.state == 'error' ||
                  (item.state == 'success' && deviateState != 'success')
                  ">
                      <b-col cols="1"> </b-col>
                      <b-col v-if="item.state == 'error'">
                        <p class="text-revamp-color-orange font-anuphan-bold-14">
                          อัปโหลดไม่สำเร็จ กรุณาลองใหม่
                          อีกครั้งหรือข้ามการอัปโหลดเอกสารนี้
                        </p>
                      </b-col>
                      <b-col v-if="item.state == 'success'">
                        <p class="text-revamp-color-success font-anuphan-bold-14">
                          อัปโหลดสำเร็จ
                        </p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </div>
    </div>
    <div>
      <!-- Deviate Card Infomation -->
      <b-card class="card-border-radius noborder mt-3" body-class="body-landing"
        style="background-color: rgba(214, 237, 255, 1) !important">
        <b-row class="d-flex">
          <b-col cols="1" class="d-flex">
            <b-col>
              <b-img :src="revampIconInfomation" width="16" height="16" class="mb-1" />
            </b-col>
          </b-col>
          <b-col class="d-flex">
            <span class="font-anuphan-regular-14 text-revamp-color-grey ml-3" style="margin-top: 2px">
              การปลอมแปลงเอกสารมีผลต่อการพิจารณาสินเชื่อ
            </span>
          </b-col>
        </b-row>
      </b-card>
      <!-- Btn action -->
      <div style="padding-top: 32px; padding-bottom: 20px">
        <div v-if="showSubmited()">
          <b-row v-if="updateRender">
            <b-col>
              <button @click="doSubmit()" :class="'btn btn-block btn-submit-landing-page' +
                  (isUpload ? ' btn-loading' : '')
                  " type="button" style="line-height: 27px" :disabled="!validateState()">
                <span v-if="isUpload">กำลังอัปโหลดเอกสาร</span>
                <span v-else-if="firstSubmit()">อัปโหลดเอกสาร</span>
                <span v-else>อัปโหลดอีกครั้ง</span>
              </button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <b-modal no-close-on-backdrop no-close-on-esc id="bv-modal-uploading" v-model="isUpload" hide-header
      hide-header-close hide-footer content-class="modal-content-custom"
      dialog-class="modal-custom-center modal-width-custom">
      <div class="justify-content-center text-center">
        <b-row class="justify-content-md-center">
          <b-col>
            <Lottie :options="animationOptions" />

          </b-col>

          <div class="w-100" />

          <b-col align-self="center"><b class="text-revamp-color-black font-anuphan-bold-16">กำลังอัปโหลดเอกสาร
              <br />กรุณาอย่าปิดหน้านี้ หรือออกจากแอปฯ</b></b-col>
          <div class="w-100 py-1" />
          <b-col><span class="text-revamp-color-black font-anuphan-regular-14">
              เมื่อสำเร็จแล้ว ระบบจะพาคุณเข้าสู่ขั้นตอนถัดไป</span>
          </b-col>
          <div class="w-100 py-1" />
          <b-col class="text-revamp-color-success font-anuphan-bold-14">สำเร็จ {{ cnt_uploading }}/{{ cnt_max_uploading
            }}
            เอกสาร</b-col>
        </b-row>
      </div>
    </b-modal>
    <template v-if="userData.isAndroid">
      <input id="fileCamera" @change="onFileChange($event)" type="file" capture hidden
        accept="image/jpeg,image/png,image/jpg,image/heic" />
    </template>
    <template v-else>
      <input id="fileCamera" @change="onFileChange($event)" type="file" hidden multiple
        accept="image/jpeg,image/png,image/jpg,image/heic,application/pdf" />
    </template>
  </div>
</template>

<script>
import {
  ErrorAlert,
  ErrorAlertHandler,
} from "@/utils/errorAlert/ErrorAlert.js";
import { GA_ACTIONS, PRODUCT_TYPE } from "@/utils/Constants.js";
import { getFileSize } from "@/utils/FileSize.js";
import { Warning, WarningWithCallback } from "@/utils/popup/Warning.js";
import axios from "axios";
const { Error } = require("@/utils/popup/Error");
const { errorDefinitions } = require("@/utils/errorAlert/errorDefinitions");
const { uploadLottie } = require("@/utils/lottie.js")
import Lottie from 'vue-lottie/src/lottie.vue'
export default {
  components: {
    ComponentMiniUpload: () =>
      import("@/components/TemplateNewScreen/revamp/CommonMiniUpload.vue"),
    Lottie
  },
  data() {
    return {
      imgExpire: require("@/assets/images/foundationIllustrationContextualVayuApplicationFail@3x.png"),
      imgSwalErr: require("@/assets/images/foundationIllustrationGenericError@3x.png"),
      imgArrowRight: require("@/assets/images/foundationIconSimpleSystemArrowRight@3x.png"),
      iconUploadsError: require("@/assets/images/foundationIconSimpleObjectStatusesFailed.png"),
      iconUploadsSuccess: require("@/assets/images/foundationIconSimpleComponentSnackbarUploadSuccessGreen.png"),
      iconUploading: require("@/assets/images/foundationIconSimpleComponentSnackbarUpload.png"),
      iconUploadated: require("@/assets/images/foundationIconSimpleComponentSnackbarSuccessBlue.png"),
      imgArrowNone: require("@/assets/images/foundationIconSimpleSystemArrowRight.png"),
      imgUploading: require("@/assets/images/downloading.png"),
      revampIconInfomation: require("@/assets/images/revamp-information-ic.png"),
      revampIconResubmit: require("@/assets/images/revamp-resubmit-ic.png"),
      documentGroup: {},
      axiosInstance: null,
      timeout: parseInt(process.env.VUE_APP_TIMEOUT),
      maxsize: parseInt(process.env.VUE_APP_MAXSIZE),
      urlRedirect: process.env.VUE_APP_APIURL_REDIRECT,
      user: {},
      isUpload: false,
      updateRender: 1,
      countDocTypeUploading: 0,
      countDocTypeAttachfile: 0,
      urlapi: process.env.VUE_APP_APIURL,
      groupRequire: [],
      groupDeviate: [],
      docList: [],
      modalShow: false,
      errorDialogTitle: "",
      errorDialogMessage: "",
      errorDialogHeader: "",
      errorDialogImage: null,
      collapseList: [],
      deviateState: "wait",
      cnt_max_uploading: 0,
      cnt_uploading: 0,
      state: "PROCESS",
      productRevamp: process.env.VUE_APP_PRODUCT_REVAMP,
      rdFlag: false,
      animationOptions: {
        animationData: uploadLottie
      }
    };
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    getHeight() {
      return window.innerHeight - 45;
    },
    lstDocumentTypeNotDeviate() {
      return this.documentType.filter((item) => !item.deviate_flag).sort();
    },
    lstDocumentTypeDeviate() {
      return this.documentType.filter((item) => item.deviate_flag).sort();
    },
    sumMaxSizeByListDocumentType() {
      let totalSize = 0;
      this.lstDocumentTypeDeviate.forEach((docType) => {
        const size = Number(
          docType.totalFileSize !== undefined &&
            docType.totalFileSize !== null &&
            !["error", "warning", "overlimit"].includes(docType.state) &&
            docType.filesReal.length > 0
            ? docType.totalFileSize
            : docType.max_size * (1000 * 1000)
        );
        totalSize += size;
      });
      return getFileSize(Number(totalSize));
    },
  },
  beforeUpdate() {
    this.updateFileUploading();
    this.groupRequire = this.lstDocumentTypeNotDeviate;
    this.deviateSetState();
  },
  mounted() {
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  created() {
    this.$callback.gaTagging({
      action: GA_ACTIONS.VIEW,
      category: "DGLSelfApplyDocumentUpload",
      label: ""
    },
      [
        {
          key: 38,
          value: PRODUCT_TYPE.SMART_MONEY
        }
      ])
    this.circuitBreaker = false;
    this.$event.$on("onExitCallback", () => this.alertExit());
    //inital listener
    // console.log("this.user.listener.landing", this.userData.listener);
    this.updateFileUploading();
    if (this.userData.listener) {
      this.$event.$on("onUploadCallback", (doctumentType) => {
        // console.log("onUploadCallback", doctumentType.doc_code);
        const docGroup = this.userData.document_group_type.find(
          (i) => i.grp_id == doctumentType.doc_group_code
        );
        this.$set(
          docGroup,
          "state",
          this.setStateGroupDocument(docGroup.grp_id)
        );
        this.updateRender += 1;
      });
      this.userData.listener = false;
      this.$store.dispatch("setUserData", this.userData);
    }
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      console.error(err);
    }
    let currentMenu = {
      pageCode: "CommonLanding",
      pageName: "อัปโหลดเอกสาร",
      previousPage: "",
    };
    this.$event.$emit("update_current_menu", currentMenu);
    this.documentGroup = this.userData.document_group_type;
    this.documentType = this.userData.documentType;
    // console.log("created()");
    for (let item of this.documentGroup) {
      // console.log(item.grp_name, item.state);
      if (item.state == "wait" || item.state == "attachfile") {
        item.state = this.setStateGroupDocument(item.grp_id);
      }
      if (
        item.grp_id === "01" &&
        item.state != "success" &&
        item.state != "error"
      ) {
        item.state = this.setStateGroupDocument(item.grp_id);
      }
      if (item.lst_doc_id.length > 1) {
        this.checkStateDocumentGroupMoreThanOneDocId(item);
      }
      //regis collapseList
      this.collapseList.push({ grp_id: item.grp_id, visible: true });
    }
    const fnSet = this.setIsLoading;
    this.axiosInstance = axios.create({
      baseURL: this.urlapi,
      timeout: this.timeout,
      headers: { Authorization: this.userData.uuid },
    });
    this.axiosInstance.interceptors.request.use(
      function (config) {
        fnSet(true);
        return config;
      },
      function (error) {
        console.error("Error from axios interceptor request", error);
        fnSet(false);
        // Do something with request error
        return Promise.reject(error);
      }
    );
    this.axiosInstance.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        fnSet(false);
        return Promise.reject(error);
      }
    );
    this.groupRequire = this.lstDocumentTypeNotDeviate;
    if (this.lstDocumentTypeDeviate.length > 0) {
      this.deviateSetState();
    }

    if (this.userData.rdFlag !== undefined)
      this.rdFlag = this.userData.rdFlag;

  },
  beforeDestroy() {
    this.$event.$off("onExitCallback");
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  },
  methods: {
    errorToString(error) {
      if (error instanceof Error) {
        const errorDetails = {
          message: error.message,
          name: error.name,
          code: error.code || "N/A", // สำหรับ Axios error code
          config: error.config, // สำหรับ Axios request config
          stack: error.stack,
          request: error.request
        };
        return JSON.stringify(errorDetails, null, 2);
      }
      return JSON.stringify(error, null, 2);
    },
    onFileChange(event) {
      this.$event.$emit(`doc_upload_${this.doc_code}`, event);
    },
    getFileSizeAndType(fSize) {
      // console.log("fSize", fSize);
      return getFileSize(fSize);
    },
    handleVisibilityChange() {
      console.log("User left the web view or minimized the app", this.state);
      if (
        this.isHideScreen() &&
        this.isUpload &&
        ["PROCESS", "SAVE"].includes(this.state)
      ) {
        this.alertExitScreen();
      }
    },
    isHideScreen() {
      return document.visibilityState === "hidden";
    },
    updateFileUploading() {
      if (this.isUpload !== undefined && !this.isUpload) {
        let arrayDocTypeUpload = this.userData.documentType.filter(
          (docType) =>
            docType.state == "attachfile" && docType.filesReal.length > 0
        );
        this.cnt_max_uploading = arrayDocTypeUpload.length;
      }
    },
    deviateSetState() {
      if (
        this.lstDocumentTypeDeviate.filter((i) => i.state == "error").length > 0
      ) {
        this.deviateState = "error";
        return;
      }
      if (
        this.lstDocumentTypeDeviate.filter((i) => i.state == "overlimit")
          .length > 0
      ) {
        this.deviateState = "overlimit";
        return;
      }
      if (
        this.lstDocumentTypeDeviate.filter((i) => i.state == "attachfile")
          .length > 0
      ) {
        this.deviateState = "attachfile";
        return;
      }
      if (
        this.lstDocumentTypeDeviate.filter((i) => i.state == "success")
          .length == this.lstDocumentTypeDeviate.length ||
        !this.showSubmited()
      ) {
        this.deviateState = "success";
        return;
      }
      if (
        this.lstDocumentTypeDeviate.filter((i) => i.state == "success").length >
        0
      ) {
        this.deviateState = "attachfile";
        return;
      }
      this.deviateState = "wait";
    },
    setIsLoading(value) {
      this.isUpload = value;
    },
    getDocumentGroup() {
      return this.documentGroup;
    },
    getDocumentType() {
      return this.documentType;
    },
    checkDocTypeIsSuccess(grpId, state) {
      if (this.firstSubmit()) return false;
      if ("01" === grpId && state !== "error") {
        let attachfile = this.checkDocument(grpId);
        let dStatement =
          this.userData.dStatementSelected != undefined &&
          this.userData.dStatementSelected;
        let ktbStatement =
          this.userData.accountSelected != undefined &&
          this.userData.accountSelected != "";

        if (attachfile || dStatement || ktbStatement) {
          return true;
        } else {
          return false;
        }
      }

      return state === "success";
    },
    goToDocumentGroup(grpId, state) {
      if (!this.showSubmited()) return;
      //check success
      if (this.checkDocTypeIsSuccess(grpId, state)) {
        console.log("docType state : " + state);
      }
      this.userData.grpId = grpId;
      this.$store.dispatch("setUserData", this.userData);
      let docList = [];
      this.listDoc = this.userData.document_group_type.find(
        (v) => v.grp_id == grpId
      );

      for (var i = 0; i < this.listDoc.lst_doc_id.length; i++) {
        for (var j = 0; j < this.userData.documentType.length; j++) {
          if (
            this.userData.documentType[j].doc_code == this.listDoc.lst_doc_id[i]
          ) {
            docList.push(this.userData.documentType[j]);
          }
        }
      }
      if (process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT == grpId) {
        this.$router.push({
          name: this.userData.routerPath.statement,
          params: { grpId: grpId, action: "NEXT" },
        });
      } else if (docList.length == 1 && docList[0].state != "deviate") {
        this.goToUploadPage(docList[0].doc_code, grpId);
      } else {
        this.$router.push({
          name: this.userData.routerPath.documentGroup,
          params: { grpId: grpId, action: "NEXT" },
        });
      }
    },
    showSubmited() {
      return ["PENDING", "SUBMITED", "RESUBMIT"].includes(
        this.userData.followupStatus.code
      );
    },
    checkDocument(grpId) {
      let docGroup = this.userData.document_group_type.find(
        (v) => v.grp_id == grpId
      );

      const docTypeBean = this.userData.documentType.filter(
        (docType) =>
          docGroup.lst_doc_id.includes(docType.doc_code) &&
          docType.filesReal.length > 0
      );
      return docTypeBean.length > 0;
    },
    setStateGroupDocument(grp_id) {
      let state;
      if (this.checkDocument(grp_id)) {
        state = "attachfile";
      } else {
        state = "wait";
      }

      if ("01" === grp_id) {
        let attachfile = this.checkDocument(grp_id);
        let dStatement =
          this.userData.dStatementSelected != undefined &&
          this.userData.dStatementSelected;
        let ktbStatement =
          this.userData.accountSelected != undefined &&
          this.userData.accountSelected != "";

        if (attachfile || dStatement || ktbStatement) {
          state = "attachfile";
        } else {
          state = "wait";
        }
      }
      // console.log(grp_id, state);
      return state;
    },
    async doSubmit() {
      this.$callback.gaTagging({
        action: GA_ACTIONS.CLICK,
        category: "DGLSelfApplyDocumentUpload",
        label: "DGLSelfApplyDocumentUpload_Upload"
      },
        [
          {
            key: 38,
            value: PRODUCT_TYPE.SMART_MONEY
          }

        ]);
      try {
        if (this.validateState()) {
          if (this.$swal.isVisible()) return;
          if (this.rdFlag) {
            this.checkValidateRdDocumentAgain()
          } else {
            this.checkTimeOut().then(() => {
              this.doSubmitImageProcessing();
            });
          }
        } else {
          ErrorAlert("2001", "1", this);
        }
      } catch (err) {
        console.error(err);
        ErrorAlert("9999", "1", this);
      }
    },
    firstSubmit() {
      let success = this.documentGroup.filter((i) => i.state == "success");
      let error = this.documentGroup.filter((i) => i.state == "error");
      return success.length == 0 && error.length == 0;
    },
    validateState() {
      //return false = disabled
      //return true = not disabled
      if (this.documentGroup.filter((i) => i.state == "error").length > 0)
        return false;
      let countDocTypeRequireAttachWithoutStatement =
        this.getDocumentType().filter(
          (i) =>
            (i.state == "attachfile" || i.state == "success") &&
            i.filesReal.length > 0 &&
            !i.deviate_flag &&
            i.doc_group_code !== process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT &&
            !i.filesReal.some(
              (item) =>
                item?.fileHavePassword &&
                item?.fileHavePassword == true &&
                item?.fileCheckassword != true
            )
        ).length;
      let countDocTypeRequire = this.getDocumentType().filter(
        (i) => !i.deviate_flag
      ).length;

      const docTypeStatement = this.getDocumentType().find(
        (d) => d.doc_group_code === process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      if (
        docTypeStatement !== undefined &&
        (docTypeStatement.filesReal.length > 0 ||
          (this.userData.accountSelected != undefined &&
            this.userData.accountSelected != "") ||
          (this.userData.dStatementSelected != undefined &&
            this.userData.dStatementSelected))
      ) {
        countDocTypeRequireAttachWithoutStatement =
          countDocTypeRequireAttachWithoutStatement + 1;
      }
      return countDocTypeRequireAttachWithoutStatement >= countDocTypeRequire;
    },
    async doSubmitImageProcessing() {
      this.setIsLoading(true);
      let isError = false;
      this.updateRender += 1;
      this.cnt_max_uploading = 0;
      this.cnt_uploading = 0;
      let arrayDocTypeUploadIsDeviate = this.userData.documentType.filter(
        (docType) =>
          docType.state == "attachfile" &&
          docType.filesReal.length > 0 &&
          docType.deviate_flag
      );
      let arrayDocTypeUploadNotDeviate = this.userData.documentType.filter(
        (docType) =>
          docType.state == "attachfile" &&
          docType.filesReal.length > 0 &&
          !docType.deviate_flag
      );
      const arrayDocTypeUpload = arrayDocTypeUploadNotDeviate.concat(
        arrayDocTypeUploadIsDeviate
      );
      this.cnt_max_uploading = arrayDocTypeUpload.length;
      this.$forceUpdate();
      try {
        if (arrayDocTypeUpload.length > 0) {
          this.state = "SAVE";
          for (let docTypeItem of arrayDocTypeUpload) {
            if (
              docTypeItem.state == "attachfile" &&
              docTypeItem.filesReal.length > 0
            ) {
              const formData = this.getFormData(docTypeItem);
              await this.axiosInstance({
                method: "POST",
                url: "api/save",
                timeout: 600000,
                data: formData,
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }).catch((er) => {
                if (!this.circuitBreaker) {
                  if (error.code === 'ERR_NETWORK') {
                    console.error('เกิดข้อผิดพลาดในการเชื่อมต่อเครือข่าย', this.errorToString(error));
                    // แสดงข้อความแจ้งเตือนผู้ใช้
                    // เช่น "ไม่สามารถเชื่อมต่อได้ กรุณาตรวจสอบอินเทอร์เน็ตของคุณแล้วลองใหม่อีกครั้ง"
                  } else if (error.response) {
                    // กรณีที่เซิร์ฟเวอร์ตอบกลับมา แต่เป็น status code ที่ผิดพลาด (เช่น 404, 500)
                    console.error('เซิร์ฟเวอร์ตอบกลับมาพร้อมข้อผิดพลาด:', error.response.status);
                  } else {
                    // ข้อผิดพลาดอื่นๆ ที่เกิดตอนสร้าง request
                    console.error('เกิดข้อผิดพลาด:', this.errorToString(error));
                  }
                  docTypeItem.state = "error";
                  docTypeItem.filesReal = [];
                  isError = true;
                  this.handdleError(er);
                } else {
                  this.setIsLoading(false);
                }
              })
                .then((res) => {
                  if (res.data.status != "SUCCESS") isError = true;
                  this.mappingResponseSave(res, docTypeItem);
                });

              if (isError) {
                break;
              }
            }
          }
          this.$store.dispatch("setUserData", this.userData);
          this.$forceUpdate();
          this.deviateSetState();
          // console.log("isError", isError);
          if (isError) {
            this.setIsLoading(false);
            this.circuitBreaker = false;
          } else {
            this.triggerSubmit();
          }
        }
        if (arrayDocTypeUpload.length == 0) {
          this.triggerSubmit();
        }
      } catch (error) {
        if (!this.circuitBreaker) {
          console.error(
            "error doSubmitImageProcessing catch ",
            this.errorToString(error)
          );
          ErrorAlert("9999", "1", this);
        } else {
          this.setIsLoading(false);
        }
      }
    },
    mappingResponseSave(res, docTypeItem) {
      // console.log("res", res);
      try {
        if (res.data.status == "SUCCESS") {
          this.cnt_uploading += 1;
          docTypeItem.state = "success";
          docTypeItem.collapse = false;
        } else if (res.data.status == "FAIL") {
          if (
            docTypeItem.doc_group_code ===
            process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT &&
            docTypeItem.filesReal.length > 0 &&
            this.userData.accountSelected != undefined &&
            this.userData.accountSelected.length > 0
          ) {
            docTypeItem.state = "warning";
          } else {
            docTypeItem.state = "error";
          }
          docTypeItem.filesReal = [];
        }
        this.$forceUpdate();
      } catch (e) {
        docTypeItem.state = "error";
        this.$forceUpdate();
      }
    },

    getFormData(docTypeObject) {
      let formData = new FormData();
      let password = [];
      if (docTypeObject.filesReal !== undefined) {
        docTypeObject.filesReal.forEach((f) => {

          if (f.file !== undefined) {
            if (this.isStatement(docTypeObject)) {
              formData.append(f.type + "_mainAccount", f.file);
            } else {
              formData.append(f.type, f.file);
            }
          }
          if (!f.fileHavePassword && f.password != undefined) {
            password.push(f.file.name + "|" + f.password);
          }
        });
      }
      formData.append("doc_code", docTypeObject.doc_code);
      if (password.length > 0) formData.append("lst_password", password);
      return formData;
    },
    getFormDeviateData() {
      let grp01 = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docIdStatement;
      if (grp01 !== undefined) {
        docIdStatement = grp01.lst_doc_id[0];
      }

      let lstDeviate = [];

      this.userData.documentType.forEach((i) => {
        if (
          i.deviate_flag &&
          (i.filesReal == undefined || i.filesReal.length == 0)
        ) {
          lstDeviate.push(i.doc_code);
          i.state = "deviate";
        }
        if (
          i.doc_code == docIdStatement &&
          (i.filesReal == undefined || i.filesReal.length == 0)
        ) {
          lstDeviate.push(i.doc_code);
          i.state = "success";
        }
      });

      this.$forceUpdate();
      return {
        lstDeviate: lstDeviate,
        accountLst:
          this.userData.accountSelected != undefined
            ? this.userData.accountSelected
            : [],
        dStatementFlag:
          this.userData.dStatementSelected != undefined
            ? this.userData.dStatementSelected
            : false,
        docIdStatement: docIdStatement,
        dDocumentFlag: this.rdFlag
      };

    },
    async checkTimeOut() {
      let response;
      response = await this.axiosInstance({
        method: "GET",
        url: "api/checkTimeout",
        timeout: this.timeout,
      })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if (this.userData.channel == "WEB") {
            this.$store.dispatch("clearUserData");
          }
          this.handdleError(error);
          return response;
        });
      return response;
    },
    async sendUploads(formData) {
      this.state = "UPLOAD";
      this.axiosInstance({
        method: "POST",
        url: "/api/upload",
        data: formData,
      })
        .then((res) => {
          if (res.data.status) {
            const fn = this.setIsLoading;
            this.userData.followupStatus = {
              code: "COMPLETE",
              desc: "Pending for Approval",
              name: "คำขออยู่ระหว่างการพิจารณา",
            };
            this.$store.dispatch("setUserData", this.userData);
            this.$forceUpdate();

            //mini app url RD
            console.log("open deeplink : ", res.data.miniAppUrl);
            if (res.data.miniAppUrl !== null) {
              //call js bridge open 
              this.$callback.openInternalDeepLink(res.data.miniAppUrl);
            }


            setTimeout(function () {
              fn(false);
            }, 10000);
          } else {
            if (
              res.data.errorList !== undefined &&
              res.data.errorList.length > 0
            ) {
              res.data.errorList.forEach((doc_error) => {
                this.userData.documentType.forEach((j) => {
                  if (j.doc_code == doc_error.docCode) {
                    this.$set(j, "state", "error");
                    if (
                      process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT ===
                      j.doc_group_code &&
                      docTypeStatement.filesReal.length > 0 &&
                      this.userData.accountSelected != undefined &&
                      this.userData.accountSelected != ""
                    ) {
                      this.$set(j, "state", "warning");
                    }
                  }
                });
              });
              this.$forceUpdate();
              this.deviateSetState();
            } else {
              console.error("error sendUploads else else", res.data);
              ErrorAlert(res.data.code, "1", this);
            }
          }
        })
        .catch((error) => {
          console.error("error sendUploads catch", error);
          if (!this.circuitBreaker) {
            this.handdleError(error);
          } else {
            this.circuitBreaker = false;
            if (!error.response || error.response.status === 0) {
              // Retry logic
              // console.log("Network error detected. Retrying...");
              setTimeout(() => this.sendUploads(formData), 500);
            }
          }
        });
    },
    closeWeb(callDocTum) {
      let grp01 = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docIdStatement = "";
      if (grp01 !== undefined) {
        docIdStatement = grp01.lst_doc_id[0];
      }
      this.axiosInstance({
        method: "GET",
        url: process.env.VUE_APP_PATH_CLOSE_WEB,
        headers: {
          Authorization: this.userData.uuid,
        },
        params: {
          callDocTum: callDocTum,
          dStatementFlag:
            this.userData.dStatementSelected != undefined
              ? this.userData.dStatementSelected
              : false,
          docIdStatement: docIdStatement,
          dDocumentFlag: this.rdFlag
        },
      })
        .then((response) => {
          const fn = this.setIsLoading;
          if ("Y" == response.data) {
            this.userData.followupStatus = {
              code: "COMPLETE",
              desc: "Pending for Approval",
              name: "คำขออยู่ระหว่างการพิจารณา",
            };
            this.$store.dispatch("setUserData", this.userData);
            this.$forceUpdate();
          }
          // this.setIsLoading(true);
          setTimeout(function () {
            fn(false);
          }, 10000);
        })
        .catch((error) => {
          console.error("error send close web catch", error);
          if (!this.circuitBreaker) {
            this.handdleError(error);
          } else {
            this.circuitBreaker = false;
            if (!error.response || error.response.status === 0) {
              // Retry logic
              // console.log("Network error detected. Retrying...");
              setTimeout(() => this.closeWeb(callDocTum), 500);
            }
          }
        });
    },
    handdleError(error) {
      console.error("handdleError", error.message);
      this.$forceUpdate();
      this.setIsLoading(false);
      ErrorAlertHandler(error, 1, this);
    },
    triggerSubmit() {
      try {
        if (this.circuitBreaker) {
          // console.log(`circuitBreaker step trigger triggerSubmit`);
          this.setIsLoading(false);
          return;
        } else {
          if (
            this.getDocumentGroup().filter((d) => d.state == "error").length > 0
          )
            return;
          let data = this.getFormDeviateData();
          if (data) {
            this.sendUploads(data);
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    setStateDocumentGroup() {
      let arrayGroup = this.documentGroup.filter((i) => i.state == "uploading");
      arrayGroup.forEach((docGroup) => {
        let array = this.userData.documentType.filter(
          (docType) =>
            docGroup.lst_doc_id.includes(docType.doc_code) &&
            docType.state == "error"
        );
        if (array.length == 0) {
          docGroup.state = "success";
        } else {
          docGroup.state = "error";
          docGroup.errorMsg = "อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง";
        }
      });
      this.$forceUpdate();
    },
    checkDisplayGroupDeviate(item) {
      if (this.firstSubmit()) return true;
      if (
        item.state == "success" ||
        item.state == "error" ||
        item.state == "attachfile"
      )
        return true;
      return false;
    },
    goToUploadPage(doc_code, grpId) {
      this.$router.push({
        name: this.userData.routerPath.upload,
        params: { doc_code: doc_code, grpId: grpId },
      });
    },
    checkStateDocumentGroupMoreThanOneDocId(documentGroup) {
      let attachComplete = false;
      documentGroup.lst_doc_id.forEach((d) => {
        const data = this.documentType.find(
          (e) => e.doc_code == d && !e.deviate_flag
        );
        if (
          data !== undefined &&
          data.filesReal != undefined &&
          data.filesReal.length > 0
        ) {
          attachComplete = true;
        } else if (documentGroup.deviate_flag) {
          const data = this.documentType.find(
            (e) => e.doc_code == d && e.deviate_flag
          );
          if (
            data !== undefined &&
            data.filesReal != undefined &&
            data.filesReal.length > 0
          ) {
            attachComplete = true;
          }
        }
      });
      documentGroup.state = attachComplete ? "attachfile" : "wait";
    },
    covertExpiredDate(date) {
      return (
        date.substring(0, date.length - 2) +
        " 25" +
        date.substring(date.length - 2, date.length) +
        " - 23:59"
      );
    },
    checkBorderColor(state) {
      if (state == "error" || state == "overlimit") return "danger";
      if (state == "warning") return "warning";
    },
    callbackSetStateDocumentType(docType) {
      try {
        let docBean = this.userData.documentType.find(
          (d) => d.doc_code == docType.doc_code
        );
        docBean.filesReal = docType.filesReal;
        docBean.state = docType.state;
        docBean.totalFileSize =
          Number(docType.max_size) * (1000 * 1000) -
          Number(docType.filesRealSize);
        if (docBean.totalFileSize < 0) {
          docBean.state = "overlimit";
        }
        this.$forceUpdate();
        this.$store.dispatch("setUserData", this.userData);
      } catch (er) {
        console.error(er);
      }
    },
    goToDocumentGroupDeviate() {
      this.$callback.gaTagging({
        action: GA_ACTIONS.CLICK,
        category: "DGLSelfApplyDocumentUpload",
        label: "DGLSelfApplyDocumentUpload_AdditionalDoc"
      },
        [
          {
            key: 38,
            value: PRODUCT_TYPE.SMART_MONEY
          }

        ]);
      this.$router.push({
        name: this.userData.routerPath.preupload,
        params: {
          grpId: "deviate",
          action: "NEXT",
          docList: this.lstDocumentTypeDeviate,
        },
      });
    },
    alertExit() {
      this.$callback.gaTagging({
        action: GA_ACTIONS.CLICK,
        category: "DGLSelfApplyDocumentUpload",
        label: "DGLSelfApplyDocumentUpload_Close"
      },
        [
          {
            key: 38,
            value: PRODUCT_TYPE.SMART_MONEY
          }

        ]);
      WarningWithCallback(
        {
          title: "ยกเลิกการอัปโหลดเอกสาร?",
          message:
            "หากยกเลิก ข้อมูลของคุณจะไม่ถูกบันทึก<br />และต้องเลือกเอกสารใหม่อีกครั้ง",
          confirmButtonText: "ใช่",
          cancelButtonText: "ไม่ใช่",
          confirmCallBack: (result) => {
            if (result.isConfirmed) {

              this.$callback.gaTagging({
                action: GA_ACTIONS.CLICK,
                category: "DGLSelfApplyDocumentUpload",
                label: "DGLSelfApplyDocumentUpload_Close_CF"
              },
                [
                  {
                    key: 38,
                    value: PRODUCT_TYPE.SMART_MONEY
                  }

                ]);
              this.goToExitEntryPoint();

            } else {
              this.$callback.gaTagging({
                action: GA_ACTIONS.CLICK,
                category: "DGLSelfApplyDocumentUpload",
                label: "DGLSelfApplyDocumentUpload_Close_CC"
              },
                [
                  {
                    key: 38,
                    value: PRODUCT_TYPE.SMART_MONEY
                  }

                ]);
            }

          },
        },
        this.$swal
      );
    },
    goToExitEntryPoint() {
      try {
        this.$callback.exitEntryPoint();
      } catch (err) {
        console.error(err);
      }
    },
    alertExitScreen() {
      Warning(
        {
          state: "error",
          title: "ไม่สามารถอัปโหลดเอกสารได้",
          message:
            "เนื่องจากคุณออกจากแอปฯ<br />ขณะกำลังอัปโหลดเอกสาร<br />กรุณาอัปโหลดเอกสารใหม่อีกครั้ง",
          confirmButtonText: "ตกลง",
          confirmCallBack: () => {
            // window.location.href = `${this.urlRedirect}/upload?authorizationCode=${this.userData.accessToken}`
            this.$router.push(
              `/upload?authorizationCode=${this.userData.accessToken}`
            );
          },
        },
        this.$swal
      );
    },
    checkHistoryUpload(docCode) {
      let history = this.userData.historyUploads.find(
        (i) => i.doc_code == docCode
      );
      return history.doc_upload_date !== null;
    },
    onReceiveNativeCommand(doc_code) {
      this.doc_code = doc_code;
      return true;
    },
    async openPopupRDdocument() {
      if (!this.rdFlag) {
        this.$callback.gaTagging({
          action: GA_ACTIONS.CLICK,
          category: "DGLSelfApplyDocumentUpload",
          label: "DGLSelfApplyDocumentUpload_dDocument"
        },
          [
            {
              key: 38,
              value: PRODUCT_TYPE.SMART_MONEY
            }

          ]);
        try {
          const res = await this.checkValidateRdDocument()
          const whiteListStatusCode = [5014, 5015, 5016, 5017, 5019, 2000];
          if (whiteListStatusCode.includes(res.data.code)) {
            if (res.data.code == 5019 || res.data.code == 5017) {

              this.$callback.gaTagging({
                action: GA_ACTIONS.ERROR,
                category: "DGLSelfApplyDocumentUpload",
                label: "คุณยังไม่เคยเปิดใช้งาน dDocument//สามารถเปิดใช้งานได้ที่บริการ > บริการ dDocument"
              },
                [
                  {
                    key: 38,
                    value: PRODUCT_TYPE.SMART_MONEY
                  },
                  {
                    key: 4,
                    value: "Status:".concat(this.userData.followupStatus.code == 'RESUBMIT' ? "RESUBMIT_DOCUMENT" : "PENDING_DOCUMENT_UPLOAD").concat(this.userData.expireDay == 1 ? ",Reminder:0" : "")
                  },
                  {
                    key: 9,
                    value: "DisplayType: Popup "
                  }


                ]);
              Warning(
                {
                  state: "warning",
                  title: "คุณยังไม่เคยเปิดใช้งาน dDocument",
                  message:
                    "สามารถเปิดใช้งานได้ที่<br />'บริการ' > 'บริการ dDocument'",
                  confirmButtonText: "ตกลง",
                  cancelButtonText: "",
                  customClass: {
                    title:
                      "swal-title-warning font-anuphan-bold-16 text-revamp-color-black",
                    confirmButton: "btn btn-info font-anuphan-bold-16 btn-ktb-WEB-v2  btn-ktb-WEB-confirm-v2 nowrap-text swal-fullwidth-btn-action"
                    ,
                    popup: "swal2-modal-WEB swal2-revamp-popup",
                    image: "swal2-image-WEB-v2",
                    htmlContainer:
                      "html-container-warning text-revamp-color-grey font-anuphan-regular-14",
                    container: "custom-swal2-backdrop-show",
                    actions: "swal-fullwidth-btn-action",
                  },

                },
                this.$swal
              );
              return
            }

          } else {
            Warning(
              {
                state: "error",
                title: "ไม่สามารถทำรายการได้",
                message:
                  "กรุณาลองใหม่ภายหลัง",
                confirmButtonText: "ตกลง",
                cancelButtonText: "",
                customClass: {
                  title:
                    "swal-title-warning font-anuphan-bold-16 text-revamp-color-black",
                  confirmButton: "btn btn-info font-anuphan-bold-16 btn-ktb-WEB-v2  btn-ktb-WEB-confirm-v2 nowrap-text swal-fullwidth-btn-action"
                  ,
                  popup: "swal2-modal-WEB swal2-revamp-popup",
                  image: "swal2-image-WEB-v2",
                  htmlContainer:
                    "html-container-warning text-revamp-color-grey font-anuphan-regular-14",
                  container: "custom-swal2-backdrop-show",
                  actions: "swal-fullwidth-btn-action",
                },

              },
              this.$swal
            );
            return
          }
        } catch (err) {
          Error(
            {
              ...errorDefinitions["FULL_SCREEN_ERROR_RD"],
              header: "อัปโหลดเอกสาร",
            },
            this.$swal
          );
          return
        }

      }
      console.log("check rdFlag")
      if (!this.rdFlag) {
        this.$swal
          .fire({

            imageUrl: require("@/assets/images/InformV2.png"),
            position: "bottom",
            title: 'ต้องการใช้ dDocument ในการยื่นเอกสาร\nเพื่อขอสินเชื่อ?',
            html: 'ระบบจะพาไปยืนยันเอกสารด้วย dDocument<br/>หลังจากอัปโหลดเอกสารประเภทอื่นๆสำเร็จ',
            confirmButtonText: "ใช้ dDocument ในการยื่น",
            confirmButtonColor: "#00A3E4",
            cancelButtonText: "ยกเลิก",
            cancelButtonColor: "#00A3E4",
            showConfirmButton: true,
            showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            customClass: {
              title:
                "swal-title-warning font-anuphan-bold-16 text-revamp-color-black",
              confirmButton: "btn btn-info font-anuphan-bold-16 btn-ktb-WEB-v2  btn-ktb-WEB-confirm-v2 nowrap-text swal-fullwidth-btn-action"
              ,
              cancelButton:
                "btn btn-info btn-ktb-WEB-v2 font-anuphan-bold-16  btn-ktb-WEB-cancle-v2 swal-fullwidth-btn-action swal-btn-cancel-rd mt-2",
              popup: "swal2-modal-WEB swal2-revamp-popup",
              image: "swal2-image-WEB-v2",
              htmlContainer:
                "html-container-warning text-revamp-color-grey font-anuphan-regular-14",
              container: "custom-swal2-backdrop-show",
              actions: "swal-fullwidth-btn-action",
            },
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$callback.gaTagging({
                action: GA_ACTIONS.CLICK,
                category: "DGLSelfApplyDocumentUpload",
                label: "DGLSelfApplyDocumentUpload_dDocument_CF"
              },
                [
                  {
                    key: 38,
                    value: PRODUCT_TYPE.SMART_MONEY
                  }

                ]);
              this.rdFlag = !this.rdFlag;
              this.userData.rdFlag = this.rdFlag;
              this.$store.dispatch("setUserData", this.userData);
            }
            else {
              this.$callback.gaTagging({
                action: GA_ACTIONS.CLICK,
                category: "DGLSelfApplyDocumentUpload",
                label: "DGLSelfApplyDocumentUpload_dDocument_CC"
              },
                [
                  {
                    key: 38,
                    value: PRODUCT_TYPE.SMART_MONEY
                  }

                ]);
            }

          });
      } else {
        this.$callback.gaTagging({
          action: GA_ACTIONS.CLICK,
          category: "DGLSelfApplyDocumentUpload",
          label: "DGLSelfApplyDocumentUpload_dDocumentCancel"
        },
          [
            {
              key: 38,
              value: PRODUCT_TYPE.SMART_MONEY
            }

          ]);
        WarningWithCallback(
          {
            state: "info",
            title: "ต้องการยกเลิกการยื่นเอกสารผ่าน \ndDocument หรือไม่ ",
            message:
              "dDocument จะถูกนำออกจากการเป็น<br />เอกสารเพิ่มโอกาสการพิจารณา",
            confirmButtonText: "ใช่",
            cancelButtonText: "ไม่ใช่",
            confirmCallBack: (result) => {
              if (result.isConfirmed) {
                this.$callback.gaTagging({
                  action: GA_ACTIONS.CLICK,
                  category: "DGLSelfApplyDocumentUpload",
                  label: "DGLSelfApplyDocumentUpload_dDocumentCancel_CF"
                },
                  [
                    {
                      key: 38,
                      value: PRODUCT_TYPE.SMART_MONEY
                    }

                  ]);
                this.rdFlag = !this.rdFlag;
                this.userData.rdFlag = this.rdFlag;
                this.$store.dispatch("setUserData", this.userData);
              } else {
                this.$callback.gaTagging({
                  action: GA_ACTIONS.CLICK,
                  category: "DGLSelfApplyDocumentUpload",
                  label: "DGLSelfApplyDocumentUpload_dDocumentCancel_CC"
                },
                  [
                    {
                      key: 38,
                      value: PRODUCT_TYPE.SMART_MONEY
                    }

                  ]);
              }


            },

          },
          this.$swal
        );
      }

    },
    async checkValidateRdDocument() {
      let response;
      response = await axios.post('api/validate-document-wallet', {}, {
        headers: { Authorization: this.userData.uuid },
        baseURL: this.urlapi,
        timeout: this.timeout,
      }
      )
        .then((response) => {
          return response;
        })
        .catch((error) => {

          this.handdleError(error);
          return response;
        });
      return response
    },
    async checkValidateRdDocumentAgain() {
      const res = await this.checkValidateRdDocument()
      console.log("checkValidateRdDocumentAgain", res)
      if (res.data.code == 2000) {
        this.checkTimeOut().then(() => {
          this.doSubmitImageProcessing();
        });
        return
      }
      if (res.data.code == 5016) {
        this.$callback.gaTagging({
          action: GA_ACTIONS.ERROR,
          category: "DGLSelfApplyDocumentUpload",
          label: "คุณขอเอกสาร dDocument\nครบจำนวนที่กำหนดของวันนี้แล้ว//คุณสามารถขอเอกสารเพิ่มได้ในวันถัดไป"
        },
          [
            {
              key: 38,
              value: PRODUCT_TYPE.SMART_MONEY
            },
            {
              key: 4,
              value: "Status:".concat(this.userData.followupStatus.code == 'RESUBMIT' ? "RESUBMIT_DOCUMENT" : "PENDING_DOCUMENT_UPLOAD").concat(this.userData.expireDay == 1 ? ",Reminder:0" : "")
            },
            {
              key: 9,
              value: "DisplayType: Popup "
            }


          ]);
        this.handdleResponseRdDocument(require("@/assets/images/InformV2.png"), 'คุณขอเอกสาร dDocument\nครบจำนวนที่กำหนดของวันนี้แล้ว', 'คุณสามารถขอเอกสารเพิ่มได้ในวันถัดไป')
        return
      }
      if (res.data.code == 5014) {
        this.$callback.gaTagging({
          action: GA_ACTIONS.ERROR,
          category: "DGLSelfApplyDocumentUpload",
          label: "กำลังจัดเตรียมเอกสารชุดก่อนหน้า//คุณสามารถทำรายการต่อได้<br />หลังจากได้รับเอกสารแล้ว"
        },
          [
            {
              key: 38,
              value: PRODUCT_TYPE.SMART_MONEY
            },
            {
              key: 4,
              value: "Status:".concat(this.userData.followupStatus.code == 'RESUBMIT' ? "RESUBMIT_DOCUMENT" : "PENDING_DOCUMENT_UPLOAD").concat(this.userData.expireDay == 1 ? ",Reminder:0" : "")
            },
            {
              key: 9,
              value: "DisplayType: Popup "
            }


          ]);
        this.handdleResponseRdDocument(require("@/assets/images/Sending.png"), 'กำลังจัดเตรียมเอกสารชุดก่อนหน้า', 'คุณสามารถทำรายการต่อได้<br />หลังจากได้รับเอกสารแล้ว')
        return
      }

      this.$swal
        .fire({
          imageUrl: require("@/assets/images/ErrorV2.png"),
          position: "bottom",
          title: 'ไม่สามารถทำรายการได้',
          html: 'กรุณาลองใหม่ภายหลัง',
          confirmButtonText: "ตกลง",
          confirmButtonColor: "#00A3E4",
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          customClass: {
            title:
              "swal-title-warning font-anuphan-bold-16 text-revamp-color-black",
            confirmButton: "btn btn-info font-anuphan-bold-16 btn-ktb-WEB-v2  btn-ktb-WEB-confirm-v2 nowrap-text swal-fullwidth-btn-action"
            ,
            cancelButton:
              "btn btn-info btn-ktb-WEB-v2 font-anuphan-bold-16  btn-ktb-WEB-cancle-v2 swal-fullwidth-btn-action swal-btn-cancel-rd mt-2",
            popup: "swal2-modal-WEB swal2-revamp-popup",
            image: "swal2-image-WEB-v2",
            htmlContainer:
              "html-container-warning text-revamp-color-grey font-anuphan-regular-14",
            container: "custom-swal2-backdrop-show",
            actions: "swal-fullwidth-btn-action",
          },
        })
      return

    },
    handdleResponseRdDocument(img, title, description) {
      this.$swal
        .fire({
          imageUrl: img,
          position: "bottom",
          title: title,
          html: description,
          confirmButtonText: "ยื่นเอกสารโดยไม่ใช้ dDcoument",
          confirmButtonColor: "#00A3E4",
          cancelButtonText: "ตกลง",
          cancelButtonColor: "#00A3E4",
          showConfirmButton: true,
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          customClass: {
            title:
              "swal-title-warning font-anuphan-bold-16 text-revamp-color-black",
            confirmButton: "btn btn-info font-anuphan-bold-16 btn-ktb-WEB-v2  btn-ktb-WEB-confirm-v2 nowrap-text swal-fullwidth-btn-action"
            ,
            cancelButton:
              "btn btn-info btn-ktb-WEB-v2 font-anuphan-bold-16  btn-ktb-WEB-cancle-v2 swal-fullwidth-btn-action swal-btn-cancel-rd mt-2",
            popup: "swal2-modal-WEB swal2-revamp-popup",
            image: "swal2-image-WEB-v2",
            htmlContainer:
              "html-container-warning text-revamp-color-grey font-anuphan-regular-14",
            container: "custom-swal2-backdrop-show",
            actions: "swal-fullwidth-btn-action",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {

            this.$callback.gaTagging({
              action: GA_ACTIONS.CLICK,
              category: "DGLSelfApplyDocumentUpload",
              label: "DGLSelfApplyDocumentUpload_Cancel"
            }, []);

            this.rdFlag = false;
            this.$store.dispatch("setUserData", this.userData);
            this.checkTimeOut().then(() => {
              this.doSubmitImageProcessing();
            });
          } else {
            this.$callback.gaTagging({
              action: GA_ACTIONS.CLICK,
              category: "DGLSelfApplyDocumentUpload",
              label: "DGLSelfApplyDocumentUpload_Confirm"
            }, []);

          }
        });
    },
    isStatement(documentType) {
      let grp01 = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docIdStatement;
      if (grp01 !== undefined) {
        docIdStatement = grp01.lst_doc_id[0];
        return docIdStatement == documentType.doc_code
      }

      return false
    },
  },
};
</script>
<style scoped>
.row-card-landing {
  padding-left: 14px;
  padding-right: 14px;
}

.body-landing {
  padding-left: 1rem;
  padding-right: 1rem;
}

.progress-bar-custom {
  height: 3px;
  border-radius: unset;
  border-bottom-left-radius: 60px 27px;
  border-bottom-right-radius: 60px 27px;
  margin-left: 2.5px;
  margin-right: 2.5px;
  background-color: unset;
}

.status-color-001 {
  color: #479e6a !important;
}

.status-color-002 {
  color: #df0747 !important;
}

.status-color-003,
.status-color-004 {
  color: #daa60b !important;
}

.status-color-PENDING,
.status-color-RESUBMIT {
  color: #df0747 !important;
}

.status-color-SUBMITED,
.status-color-SUBMITED2,
.status-color-COMPLETE {
  color: #479e6a !important;
}

.badge-primary {
  border: 1.5px solid #33c5ff;
  box-sizing: border-box;
  position: absolute;
  margin: -10px -10px;
  margin-top: 0rem;
  color: #33c5ff;
  background-color: transparent;
  width: 24px;
  height: 24px;
}

.badge-wait {
  border: 1.5px solid #c2d0d9 !important;
  box-sizing: border-box;
  margin: -10px -10px;
  margin-top: 0rem;
  color: #c2d0d9 !important;
  background-color: transparent;
  width: 24px;
  height: 24px;
  margin-left: 1%;
}

.text-danger {
  color: rgb(219, 0, 0);
  font-family: KrungthaiFast-Regular, Arial, sans-serif !important;
  font-size: 16px !important;
}

.text-resubmit {
  color: rgb(212, 150, 74);
  font-family: KrungthaiFast-Regular, Arial, sans-serif !important;
  font-size: 16px !important;
}
</style>
<style>
.text-loan-info {
  color: black !important;
  font-family: KrungthaiFast-Bold, Arial, sans-serif !important;
}

.text-label {
  color: #727a8d !important;
  font-size: 14px;
}

.position-footer {
  position: fixed;
  bottom: 0;
  margin-bottom: 10%;
}

.content-card-sm {
  min-height: 45vh;
}

.content-card-md {
  min-height: 55vh;
}

.btn-loading {
  color: rgb(145, 159, 169) !important;
  background-color: rgb(231, 235, 240) !important;
  border-color: rgb(231, 235, 240) !important;
  background-image: none !important;
}

.swal2-htmlContainer-next-fullscreen {
  font-size: 16px !important;
  margin-bottom: 25vh !important;
  margin-top: 1rem !important;
  line-height: 24px !important;
  height: 50% !important;
}

.swal2-image-next-fullscreen {
  margin-top: 10vh !important;
  margin-bottom: 10vh !important;
}

.swal2-icon {
  border-color: unset !important;
  border: unset !important;
  line-height: 20px !important;
  width: 100% !important;
  margin: 0px !important;
  align-items: unset !important;
}

.swal2-icon-content {
  font-family: KrungthaiFast-Bold, Arial, sans-serif !important;
  color: black !important;
  font-size: 20px !important;
}

.swal2-modal-next-fullscreen {
  border-radius: 0px !important;
  width: 100% !important;
  padding: 24px !important;
  height: 100vh !important;
  -webkit-animation: unset !important;
  animation: unset !important;
}

.swal2-actions-next-fullscreen {
  display: flex !important;
  justify-content: center !important;
  margin-top: 1rem !important;
  margin-right: 0px !important;
  margin-bottom: 35px !important;
  margin-left: 0px !important;
}

.chevron-rotateX {
  transform: rotateZ(90deg);
  -webkit-transition: all 0.1s ease-in-out;
  -moz-transition: all 0.1s ease-in-out;
  -o-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

.chevron-rotateY {
  transform: rotateY(0deg);
  -webkit-transition: all 0.1s ease-in-out;
  -moz-transition: all 0.1s ease-in-out;
  -o-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

.card-revamp {
  border: none;
  border-radius: 32px !important;
  box-shadow: 0px 2px 6px 0px rgba(209, 213, 219, 0.3);
}

.text-revamp-grey {
  color: rgba(107, 114, 128, 1);
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0px;
}

.text-revamp-dark-grey {
  color: rgba(17, 25, 40, 1);
}

.text-revamp-bold {
  font-weight: 600;
}

.text-revamp-bold-16 {
  color: rgba(17, 25, 40, 1);
  font-weight: 600;
  font-size: 16px;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #111928b2 !important;
  animation: opacityShow 0.3s ease-in forwards !important;
}

@keyframes opacityShow {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.d-wallet-border-radius {
  border-radius: 109px 109px 109px 108px;
  -webkit-border-radius: 109px 109px 109px 108px;
  -moz-border-radius: 109px 109px 109px 108px;
  background: #DFFF00;
  color: #015AF5;
}

.swal-fullwidth-btn-action {
  width: 100% !important;
}

.swal-btn-cancel-rd {
  border: 1px solid var(--color-button-enable) !important;
}
</style>
